import staytoenjoylogo from './assests/staytoenjoylogo.svg'
import makingcents from "./assests/makingcents.png"
import simplealliance from "./assests/simplealliance.png"
import CR from "./assests/CR.png"
import CRCover from "./assests/CR-Security-Solution.png"
import avunja from "./assests/avunja.svg"
import engineering from "./assests/2050engineering.png"
import grepcosystems from "./assests/grepcosystems.png"
import grepcosystems1 from "./assests/grepcosystems1.png"
import Nextjs from "./assests/nextjs.png"
import ReactJs from "./assests/react.png"
import NodeJs from "./assests/nodejs.png"
import MongoDB from "./assests/mongodb.png"
import TypeScript from "./assests/typescript.png"
import Redis from "./assests/redis.png"
import PostgreSQL from "./assests/postgresql.png"
import Firebase from "./assests/firebase.png"
import PasswordImage from "./assests/Password.png"
import Python from "./assests/python.png"
import Inkspire from "./assests/Inkspire.png"
import Figma from "./assests/figma.png"
const serveromProjectCover= "https://res.cloudinary.com/dncfmkek9/image/upload/v1595861551/omer%20mustafa%20web%20developer%20portfolio/serverom-big.png";
const InventoryProjectCover = "https://res.cloudinary.com/dlbm3b0oh/image/upload/v1689262949/Inventory_gdtxmk.png";
const datavisualiaztionProjectCover ="https://mubasharhussain.netlify.app/static/media/rtdv.c4df63695a52400f4528.webp";
const staytoenjoyProjectcover ='https://res.cloudinary.com/dlbm3b0oh/image/upload/v1689262523/staytoenjoy_ntxogo.png'
const shareeftex = "https://shareeftexportfolio.vercel.app/static/media/LOGO.9e2618d5c5baf5eb5b26.png"
const GoogleAnalytics = "https://www.gstatic.com/analytics-suite/header/suite/v2/ic_analytics.svg"
const MaterialUI = "https://mui.com/static/logo.png"
const Github = "https://1000logos.net/wp-content/uploads/2021/05/GitHub-logo.png"
const DigitalOcean = "https://www.digitalocean.com/_next/static/media/do-logo.d3eb8550.svg"
const Cloudinary = "https://res-s.cloudinary.com/prod/image/upload/d_console:cld_new_default_cloud_logo_regular_padding.svg/w_32,h_32,c_fill,dpr_2.0/console/customer-logos/78c1f24f2063f8cd0bc95b9b75a9cb15"
const Canva ="https://static.canva.com/web/images/12487a1e0770d29351bd4ce4f87ec8fe.svg"
const EJS = "https://ejspr.com/app/uploads/2021/03/EJS-Monogram_Grass-Green_High-Res.png"
const Shopify = "https://play-lh.googleusercontent.com/6zZznDl5GHwm_BdOTTXEpB28q1yUxjdjf1Me6qTzHw0-SH4MEjdJok0sC5Daru5suA=w600-h300-pc0xffffff-pd"

const productionAPI = "https://api.bringitgo.tech";

const clients = [
    {
        name:"2550 Engineering",
        logo:engineering,
    },
    {
        name:"CR SECURE SOLUTIONS",
        logo:CR
    },
    {
        name:"Grepco Systems",
        logo:grepcosystems1,
    },
    {
        name:"Inventory",
        logo:"https://inventory-a761c.web.app/favicon.png"
    },
    {
        name:"Shareeftex",
        logo:shareeftex
    },
    {
        name:"MakingCents",
        logo:makingcents
    },
    {
        name:"Avunja",
        logo:avunja
    },
    {
        name:"StaytoEnjoy",
        logo:staytoenjoylogo
    },
]

const projectsCovers = {
    crsecurity:{
        Image:CRCover
    },
    datavisualiaztion:{
        Image:datavisualiaztionProjectCover
    },
    dressbylinda:{
        Image:require("./assests/Linda-project-cover.png")
    },
    exposurestudio:{
        Image:require("./assests/Exposure-studio-project-cover.png")
    },
    inkspire:{
        Image:Inkspire
    },
    inventory:{
        Image:InventoryProjectCover
    },
    pinggo:{
        Image:require("./assests/Pinggo-project-cover.png")
    },
    password:{
        Image:PasswordImage
    },
    serverom:{
        Image:serveromProjectCover
    },
    shareeftex:{
        Image:require("./assests/ShareefTex.png")
    },
    staytoenjoy:{
        Image:staytoenjoyProjectcover
    },
    
}

const logoImages = [
    makingcents,
    simplealliance,
    engineering,
    grepcosystems
]

const techStack=[
    {
        name:"NextJS",
        src:Nextjs,
    },
    {
        src:ReactJs,
        name:"React"
    },
    {
        src:MaterialUI,
        name:"Material UI"
    },
    {
        src:NodeJs,
        name:"Nodejs"
    },
    {
        src:MongoDB,
        name:"MongoDB"
    },
    {
        src:TypeScript,
        name:"TypeScript"
    },
    {
        src:Redis,
        name:"Redis"
    },
    {
        src:Github,
        name:"GitHub"
    },
    {
        src:DigitalOcean,
        name:"Digital Occean"
    },
    {
        src:PostgreSQL,
        name:"PostgreSQL"
    },
    {
        src:Firebase,
        name:"Firebase"
    },
    {
        src: Figma,
        name:"Figma"
    },
    {
        src:GoogleAnalytics,
        name:"Google Analytics"
    },
    {
        src:Cloudinary,
        name:"Cloudinary"
    },
    {
        src:Canva,
        name:"Canva"
    },
    {
        src:EJS,
        name:"EJS"
    },
    {
        src:Python,
        name:"Python"
    },
    {
        src:Shopify,
        name:"Shopify"
    },
]
// Keep in sorted order
const projects = [
    {
        id: "cr-secure-solutions",
        Name: "CR Secure Solutions",
        Subtitle: "B2B Corporate Platform & Automated Service Lead Funnel",
        Industry: "Manned Guarding & Security Services",
        Company: "CR Secure Solutions Ltd",
        Location: "United Kingdom",
        Category: ["Web", "Custom Solution", "Designing"],
        Link: "/project/cr-secure-solutions", // Or their live domain: https://www.cr-security.uk/
        Image: projectsCovers.crsecurity?.Image || CR, // Uses your imported CR logo/image asset
        GIF: null,
        video: null,
        Tags: ["Corporate Web Design", "B2B Lead Generation", "Service-Based SEO", "SIA Compliance UI"],
        Challenge: `A premium UK security firm required a highly credible, multi-service corporate website capable of structuring distinct operational divisions (static guarding, mobile patrols, asset security) into a unified, high-converting B2B lead capture engine.`,
        Description: `bringIt Go engineered a responsive corporate platform built to attract enterprise security contracts. We designed an intuitive visual architecture that highlights industry compliance and licensing, streamlined the multi-page service navigation, and implemented optimized contact frameworks to convert cold commercial traffic into direct service inquiries.`
    },
    {
        Name: "Data Visualization Portal",
        id: "data-visualization",
        Subtitle: "Industrial IoT Real-Time Analytics & 3D Object Rendering",
        Industry: "Industrial Automation & Engineering",
        Company: "2550 Engineering",
        Location: "Sweden",
        Category: ["Web", "Data Visualization"],
        Link: "/project/data-visualization",
        // Stack: {
        //     interface: ["React.js", "Plotly.js", "Chart.js", ],
        //     engine: ["Node.js", "Express", "PostgreSQL", "Websockets"],
        //     // infrastructure: ["AWS Enterprise", "Docker", "Cloudflare Security"]
        // },
        // KPIs: [
        //     { value: "-75%", label: "MALWARE_VULNERABILITY_INDEX" },
        //     { value: "< 240ms", label: "GLOBAL_API_LATENCY_SPEED" },
        //     { value: "100%", label: "GDPR_COMPLIANCE_RATING" }
        // ],
        Image: datavisualiaztionProjectCover,
        GIF: "https://cdn.bringitgo.tech/dataVisualiztion.gif",
        Tags: ["IoT Web App", "3D Rendering", "Real-Time Data Streaming", "React"],
        Challenge: `Building a complex, industrial real-time data visualization web portal capable of streaming live sensor metrics from physical conveyor belts, alongside high-performance 3D object representation natively in-browser.`,
        Description: `bringIt Go designed and engineered an advanced custom web application for industrial asset tracking. The portal processes raw sensor data stream inputs to render dynamic 2D dashboards and interactive 3D graphs, visualizing critical real-time physical metrics including structural temperature boundaries, volume estimation, surface area, and rotation speeds.`
    },
    {
        id: "dresses-by-linda-and-agnes",
        Name: "Dresses by Linda & Agnes",
        Subtitle: "Custom Shopify Frontend Optimization & Boutique E-Commerce UX",
        Industry: "Boutique Retail & Bridal E-Commerce",
        Company: "Dresses by Linda And Agnes",
        Location: "USA",
        Category: ["Web", "Shopify"],
        Link: "/project/dresses-by-linda-and-agnes",
        Image: projectsCovers.dressbylinda.Image,
        GIF: "https://cdn.bringitgo.tech/Linda.gif",
        Tags: ["Shopify Development", "UI/UX Optimization", "E-Commerce Fixes"],
        Challenge: `The client required expert Shopify theme customization and frontend quick-fixes to resolve core store interface bugs that were driving bounce rates up and devaluing their online digital sales funnel.`,
        Description: `bringIt Go stepped in to handle website maintenance and bespoke liquid theme customization. We reworked the store's frontend interface layout to establish an intuitive checkout journey, optimization for mobile devices, and unique asset presentations tailored to luxury retail aesthetics.`
    },
    {
        id: "exposure-studio",
        Name: "Exposure Studio",
        Subtitle: "Custom Print-on-Demand Shopify Development & Speed Optimization",
        Industry: "Custom Printing E-Commerce",
        Company: "Exposure Studio",
        Location: "UK",
        Category: ["Web", "Shopify"],
        Link: "/project/exposure-studio",
        Image: projectsCovers.exposurestudio.Image,
        GIF: null,
        Tags: ["Shopify Customization", "Frontend Support", "Conversion Rate Optimization"],
        Challenge: `A high-volume custom design and printing store operating on Shopify was encountering performance roadblocks and layout errors that impacted their user acquisition and digital marketing conversion rates.`,
        Description: `We provided targeted technical website support and core theme enhancements. bringIt Go audited the custom printing system workflows, cleaned the scripts, and redesigned standard components to deliver a fluid, high-converting checkout experience for desktop and mobile users.`
    },
    {
        id: "inkspire",
        Name: "Inkspire",
        Subtitle: "Web3 Blogging Portal & Smart Contract Integration",
        Industry: "SaaS & Vite Blockchain Applications",
        Company: "Making Cents",
        Location: "United Kingdom",
        Category: ["Web", "Custom Solution", "Designing", "Cloud Hosting", "Blockchain"],
        Link: "/project/inkspire",
        Image: Inkspire,
        GIF: "https://cdn.bringitgo.tech/inkspire.gif",
        video: "GOLO6DF3_xo",
        Tags: ["Web3 Platform", "Smart Contracts", "UI/UX Prototype", "Cloud Deployment"],
        Challenge: `Architecting a decentralized social publishing platform requiring native Vite blockchain integration to automatically process micro-cryptocurrency reward allocations for global content creators and audiences securely.`,
        Description: `bringIt Go designed and deployed a full-stack web application from initial asset blueprint to cloud infrastructure deployment. We optimized code architecture dependencies to minimize cloud resource run costs, performed pre-launch sandbox test deployments, and engineered the complete smart-contract ecosystem to match structural business workflows.`
    },
    {
        id: "inventory-store",
        Name: "Inventory",
        Subtitle: "Serverless E-Commerce System & Automated Analytics Tracking",
        Industry: "Retail & Multi-Marketplace Logistics",
        Company: "Inventory Store",
        Location: "Pakistan",
        Link: "/project/inventory-store",
        Category: ["Web", "Custom Solution", "Designing", "Cloud Hosting"],
        Image: InventoryProjectCover,
        GIF: null,
        video: null,
        Tags: ["Serverless Architecture", "Custom CRM App", "Google Ads Engine"],
        Challenge: `Building a lightning-fast, tailored alternative to standard template storefronts by assembling a serverless prototype interface equipped with advanced automated sales analytics under a highly compressed release deadline.`,
        Description: `We developed an all-in-one custom e-commerce solution running on scalable serverless microservices. The application integrates deep structural logic for tracking real-time audience purchase behavior, custom stock inventory systems, and programmatic Google Ads script triggers to maximize ad-spend performance seamlessly.`
    },
    {
        id: "pinggo",
        Name: "Pinggo Invitation Platform",
        Subtitle: "Interactive SaaS Frontend Interface & Digital Asset Workflows",
        Industry: "Event Management & SaaS Platforms",
        Company: "Pinggo",
        Location: "United Kingdom",
        Link: "/project/pinggo",
        Category: ["Web", "Custom Solution", "Designing"],
        Image: projectsCovers.pinggo.Image,
        GIF: null,
        video: null,
        Tags: ["SaaS Frontend", "Product Interface UI", "Responsive Design Patterns"],
        Challenge: `A dynamic software platform required an intuitive client-facing management application UI to gracefully display custom event workflows, invitation analytics, and simplify product navigation maps for non-technical users.`,
        Description: `bringIt Go executed the product design and dynamic frontend implementation using modular, reusable interface system frameworks. The completed application translates sophisticated cloud mechanics into clear interactive visual components that optimized onboarding loops for their market release.`
    },
    {
        id: "serverom",
        Name: "Serverom Cloud Platform",
        Subtitle: "Automated Cloud Server Orchestration & Stack Performance Engineering",
        Industry: "DevOps & Cloud Hosting Services",
        Company: "Serverom Services",
        Location: "Pakistan",
        Link: "/project/serverom",
        Category: ["Web", "Custom Solution", "Designing", "Cloud Hosting"],
        Image: serveromProjectCover,
        GIF: null,
        video: null,
        Tags: ["Cloud Automation", "DevOps Systems", "SSL Automation", "Server Optimization"],
        Challenge: `Developing a high-performance web dashboard tool that entirely automates single-click cloud provider configuration deployments, secure SSL handshakes, database allocation maps, and content management stack installations.`,
        Description: `bringIt Go built a managed hosting cloud management service console utilizing specialized optimization tuning layers. Rigorous traffic load simulation testing validated that the platform's custom deployment architecture ran up to four times faster than default industry web server builds while demanding significantly fewer backend resources.`
    },
    {
        id: "shareef-tex",
        Name: "Shareef Tex Enterprise",
        Subtitle: "B2B Global Product Catalog Engine & International Trade Presentation",
        Industry: "PPE Manufacturing & Industrial Export",
        Company: "ShareefTex International",
        Location: "Pakistan",
        Link: "/project/shareef-tex",
        Category: ["Designing", "Web", "AEO & SEO", "Hosting"],
        Image: projectsCovers.shareeftex.Image,
        GIF: null,
        video: null,
        Tags: ["B2B Catalog Design", "Industrial Web Services", "Corporate Digitalization"],
        Challenge: `Transitioning an established international enterprise manufacturing operator away from paper-based legacy wholesale booklets by converting complex commercial product specs into a permanent digital catalog environment.`,
        Description: `bringIt Go systematically mapped high-density industrial specification inventories into an interactive web asset interface directory. The platform empowers cross-border trade procurement buyers to seamlessly scan, search, and parse high-volume product catalogs across diverse devices.`
    },
    {
        id: "staytoenjoy",
        Name: "StayToEnjoy Network",
        Subtitle: "Social E-Commerce Portal & High-Concurrency Systems Engineering",
        Industry: "Marketplace Platforms & Social Media Networks",
        Company: "StayToEnjoy",
        Location: "Germany",
        Link: "/project/staytoenjoy",
        Category: ["Web", "Custom Solution", "Designing", "Cloud Hosting"],
        Image: staytoenjoyProjectcover,
        GIF: null,
        video: null,
        Tags: ["Social Commerce Hub", "Agile Microservices", "High-Load Infrastructure"],
        Challenge: `Engineering a massive hybrid web environment merging intense social network components with multi-vendor payment rails on an optimized budget footprint under rigid launch target schedules.`,
        Description: `We applied strict agile architecture engineering paradigms to implement a distributed data management framework. By selecting high-efficiency software engines and isolating system run tasks, bringIt Go created a single fluid ecosystem balancing dense chat features with shopping carts without data overhead latency.`
    },
    {
        id: "passwordscript",
        Name: "Automated Encryption Scripts",
        Subtitle: "Custom Desktop OS Security Extensions & Internal Tools Automation",
        Industry: "Internal Utilities & Data Security",
        Company: "Freelance Client Integration",
        Location: "Pakistan",
        Link: "/project/passwordscript",
        Category: ["Scripts"],
        Image: PasswordImage,
        GIF: null,
        video: null,
        Tags: ["Custom OS Scripts", "Automation Scripting", "Data Management Tools"],
        Challenge: `The user required custom operating system automation scripts to quickly query secure password lists directly from system hotkeys to improve administrative operation output velocities.`,
        Description: `We engineered and documented lightweight, native desktop platform automation scripts. The custom programmatic service bridges encryption keys securely with fast-access run prompts, optimizing workflow tasks to bypass bloated third-party middleware interfaces safely.`
    }
];

const constants = {
    productionAPI,
    clients,
    logoImages,
    techStack,
    projectsCovers,
    projects
}

export default constants
